(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("gettingStarted", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/setup/gettingStartedView.html",
            controller: ["tenantResource", "messageService", "$translate", "colorService", GettingStartedCtrl],
            controllerAs: "vm"
        };
        function GettingStartedCtrl(tenantResource, messageService, $translate, colorService) {
            var vm = this;
            vm.loading = true;
            tenantResource.getDashboardTenancySetupViewModel(function (data) {
                vm.data = data;
                vm.data.completionChart = {
                    data: [{
                            label: $translate.instant("settings.tenancySetup.panel.siteSetupCompletion.completedLabel"),
                            value: vm.data.percentCompletion,
                            color: vm.data.percentCompletion === 100 ? colorService.getSuccessColor() : colorService.getDangerColor(),
                            suffix: "%"
                        }],
                    options: { thickness: 20, mode: "gauge", total: 100 }
                };
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
        }
    });
}());
